import { useNavigate } from "react-router-dom";
import { WrenchIcon } from "lucide-react"; // Icono de mantenimiento
import { trn } from "../shared/i18n";

const Maintenance = () => {
  const navigate = useNavigate();

  return (
    <div className="fullscreen-container text-center">
      <div className="fullscreen-content">
        <h1 className="text-warning">
          <WrenchIcon size={48} /> {trn("app.consumer.maintenance.title", "Maintenance")}
        </h1>
        <p className="mt-3">{trn("app.consumer.maintenance.body", "The system is under maintenance. Please try again later.")}</p>
        <button className="btn btn-secondary btn-lg mt-4" onClick={() => navigate("/")}>
          {trn("app.consumer.maintenance.back_home", "Back to home")}
        </button>
      </div>
    </div>
  );
};

export default Maintenance;
